import { format } from "date-fns";
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

export function EmptyValue() {
  return <span className="text-muted-foreground">—</span>;
}

export function RatingCell({ rating }: { rating?: string | number | null }) {
  if (rating === null || rating === undefined || rating === "") return <EmptyValue />;
  const n = typeof rating === "string" ? parseFloat(rating) : rating;
  if (Number.isNaN(n)) return <EmptyValue />;
  return (
    <span className="inline-flex items-center gap-1">
      <Star className="size-[11px] fill-star text-star-stroke" strokeWidth={1.5} aria-hidden />
      {n.toFixed(1)}
    </span>
  );
}

export function PriceCell({ priceLevel }: { priceLevel?: number | null }) {
  if (priceLevel === null || priceLevel === undefined) return <EmptyValue />;
  return <span>{"$".repeat(priceLevel + 1)}</span>;
}

export function DateCell({ date }: { date?: string | Date | null }) {
  if (!date) return <EmptyValue />;
  const d = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return <EmptyValue />;
  return <span className="text-muted-foreground">{format(d, "MMM d, yyyy")}</span>;
}

/** Wraps row actions so they appear on row hover/focus, and always on touch devices. */
export function RowActions({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className={cn(
        "flex items-center justify-end gap-0.5 opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100 has-[[data-state=open]]:opacity-100 [@media(hover:none)]:opacity-100",
        className
      )}
    >
      {children}
    </div>
  );
}

export function ExternalTextLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="text-foreground underline decoration-border underline-offset-[3px] hover:decoration-foreground"
    >
      {children}
    </a>
  );
}
